import { render, staticRenderFns } from "./OrderCtrl.vue?vue&type=template&id=331d2ce2&"
import script from "./OrderCtrl.vue?vue&type=script&lang=js&"
export * from "./OrderCtrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports